import { createSlice } from "@reduxjs/toolkit";

const clientSlice = createSlice({
  name: "client",
  initialState: {
    loading: false,
    error: null,
    clients: [],
    totalCount: {},
    clientProfileUiid: null,
    currentClient: {
      clientDetails: {},
      loadedTabs: [],
    }, // Add this for single employee data
  },
  reducers: {
    clearClientData(state) {
      state.clients = [];
      state.totalCount = {};
      state.clientProfileUiid = null;
      state.currentClient = {
        clientDetails: {},
        loadedTabs: [],
      };
    },
    clearClientProfile(state) {
      console.log("clearClientProfile called");
      state.clientProfileUiid = null;
      state.currentClient = {
        clientDetails: {},
        loadedTabs: [],
      };
    },
    setClientProfile(state, action) {
      console.log("action.payload in set client", action.payload);
      state.currentClient.clientDetails = {
        ...state.currentClient.clientDetails,
        ...action.payload,
      };
    },
    addToDraft(state, action) {
      console.log("action.payload in addto draft", action.payload);
      state.currentClient.clientDetails = {
        ...state.currentClient.clientDetails,
        ...action.payload,
      };
    },
    getClientsStart(state, action) {
      const { limit, page, employmentType } = action.payload;
      state.loading = true;
    },
    getClientsSuccess(state, action) {
      state.loading = false;
      state.clients = action.payload.data; // Store paginated data
      state.totalCount = action.payload.totalCount; // Store total count
    },
    getClientsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    // Add Client
    addNewClientStart(state) {
      state.loading = true;
      state.error = null;
    },

    addNewClientSuccess(state, action) {
      state.clientProfileUiid = action.payload.data.uiid;
      state.loading = false;
      state.draft = null;
      state.lastSaved = null;
    },

    addNewClientFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateClientStart(state) {
      state.loading = true;
      state.error = null;
    },

    updateClientSuccess(state, action) {
      state.loading = false;
      state.draft = null;
      state.lastSaved = null;
    },

    updateClientFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    addContactStart(state) {
      state.loading = true;
      state.error = null;
    },

    addContactSuccess(state) {
      state.loading = false;
      state.draft = null;
      state.lastSaved = null;
    },

    addContactFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateContactStart(state) {
      state.loading = true;
      state.error = null;
    },

    updateContactSuccess(state) {
      state.loading = false;
      state.draft = null;
      state.lastSaved = null;
    },

    updateContactFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    getClientOneStart(state) {
      state.loading = true;
      state.error = null;
    },
    getClientOneSuccess(state, action) {
      state.loading = false;
      state.clientProfileUiid = action.payload.data.uiid
        ? action.payload.data.uiid
        : state.clientProfileUiid;
      state.currentClient.clientDetails = {
        ...state.currentClient.clientDetails,
        ...action.payload.data,
      };
      state.draft = null;
      state.lastSaved = null;
    },
    getClientOneFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetCurrentClient(state) {
      state.currentClient = {
        clientDetails: {},
        loadedTabs: [],
      };
    },
  },
});

export const {
  getClientsStart,
  getClientsSuccess,
  getClientsFailure,
  addNewClientStart,
  addNewClientSuccess,
  addNewClientFailure,
  updateClientStart,
  updateClientSuccess,
  updateClientFailure,
  addContactStart,
  addContactSuccess,
  addContactFailure,
  updateContactStart,
  updateContactSuccess,
  updateContactFailure,
  clearClientProfile,
  getClientOneStart,
  getClientOneSuccess,
  getClientOneFailure,
  resetCurrentClient,
  setClientProfile,
  clearClientData,
  addToDraft,
} = clientSlice.actions;
export default clientSlice.reducer;
